<template>
    <div v-if="client">
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Languages</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div v-for="language in allLanguages" :key="language" class="switch-item">
                        <input
                            :id="language"
                            :name="language"
                            type="checkbox"
                            class="switch"
                            :checked="client.settings.viewSettings.languageSettings.languages.indexOf(language) > -1"
                            @change="toggleLanguage(language)"
                        />
                        <label :for="language">{{language}}</label>
                    </div>
                </div>
            </div>
        </div>

        <div class="field-body">
            <div class="field is-grouped">
                <div class="control">
                    <button @click="save" class="button is-primary">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import state from '../../../../../state';
import utils from '../../../../../utils';
import clientService from '../../../../../services/client.service';

export default {
    name: 'client-settings-view-menu',
    data() {
        return {
            client: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        allLanguages() {
            return state.languages.get();
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async save() {
            await clientService.save(this.client);
            this.loadClient();
        },
        toggleLanguage(lang) {
            if (this.client.settings.viewSettings.languageSettings.languages.indexOf(lang) > -1) {
                this.client.settings.viewSettings.languageSettings.languages.splice(this.client.settings.viewSettings.languageSettings.languages.indexOf(lang), 1);
            } else {
                this.client.settings.viewSettings.languageSettings.languages.push(lang);
            }
        }
    }
};
</script>

<style scoped>
.switch-item {
    margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/view/language.vue